import OverlayBase from 'stimulus/overlay_base';

const CLOSING_CLASS = 'ui-sheet-overlay--closing';

export default class extends OverlayBase {
  static targets = ['sheet'];

  get panel() {
    return this.hasSheetTarget ? this.sheetTarget : null;
  }

  get triggerSelector() {
    return `[data-sheet-trigger="${this.element.id}"]`;
  }

  open() {
    this.element.classList.remove(CLOSING_CLASS);
    super.open();
  }

  requestClose() {
    if (this.element.hidden) return;

    this.element.classList.add(CLOSING_CLASS);
  }

  dismiss() {
    this.requestClose();
  }

  animationEnd(event) {
    if (event.target !== this.sheetTarget) return;
    if (!this.element.classList.contains(CLOSING_CLASS)) return;

    this.element.classList.remove(CLOSING_CLASS);
    this.finishClose();
  }
}
